import RangeSlider from 'react-range-slider-input';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters';
import coinsSidebar from '../../../assets/images/icons/coinsSidebar.svg';
import companySidebar from '../../../assets/images/icons/companySidebar.svg';
import home from '../../../assets/images/icons/home.svg';
import route from '../../../assets/images/icons/route.svg';
import user from '../../../assets/images/icons/user.svg';
import AppHeader from '../../../components/AppHeader';
import Button from '../../../components/Button';
import { CustomStyle } from '../../../components/CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../components/CustomSelectStyleDarkTheme';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../components/FormGroup';
import FullAddressForm from '../../../components/FullAddressForm';
import Input from '../../../components/Input';
import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import PageHeader from '../../../components/PageHeader';
// import { IWorkplacesOptions } from '../../../components/RoutingResult/types';
import info from '../../../assets/images/icons/info.svg';
import { SecondaryButton } from '../../../components/SecondaryButton';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import { useAppContext } from '../../../contexts/auth';
import isCpfvalid from '../../../utils/isCpfValid';
import renderArray from '../../../utils/renderArrayWithComa';
import AsksGoToExistingResultModal from './components/AsksGoToExistingResultModal';
import { Card, InnerDataContainer, RangeSliderContainer, SelectedViewContainer } from './styles';
import { IWorkplacesOptions } from './types';
import useNewConsult from './useNewConsult';

export default function NewConsult() {
  const {
    isLoading,
    companyCode,
    getErrorMessageByFieldName,
    newConsultData,
    handleRegistrationChange,
    handleNameChange,
    handleEmailChange,
    handleCellphoneChange,
    newCoords,
    onLatChange,
    onLngChange,
    onCepChange,
    onStreetNameChange,
    onNumberChange,
    onDistrictChange,
    onCityChange,
    onUfChange,
    handleCpfChange,
    setError,
    removeError,
    valueLabelByCorrespondingWorkplace,
    workplacesOptions,
    handleSelectedWorkplaceChange,
    selectedTheme,
    correspondingWorkplace,
    navigateToWorkplaceEditPage,
    setIsLoading,
    hasError,
    handleTryAgain,
    handleUsesMirroringChange,
    handleUsesAffreightmentChange,
    selectedWalkDistance,
    handleWalkDistanceSelection,
    setSelectedWalkDistance,
    handleCeilingValueChange,
    // handleInitialValueChange,
    handleUsesNoTaxTickets,
    handleRJIntegration,
    handleEntryTimeChange,
    handleExitTimeChange,
    handleWorkDaysChange,
    handleIsHighSalaryChange,
    isValidToConfirm,
    sendForRouting,
    canChooseUsesAffreightment,
    consultType,
    handleConsultTypeChange,
    selectedWorkplaces,
    setSelectedWorkplaces,
    routeName,
    handleRouteNameChange,
    requiredFieldsErrorsLabel,
    isGettingMyPlace,
    asksGoToExistingResultModalData,
    setAsksGoToExistingResultModalData,
  } = useNewConsult();

  const animatedComponents = makeAnimated();
  const { isDifferentSubdomain } = useAppContext();

  const customWorkplaceSelectFilter = (option: FilterOptionOption<IWorkplacesOptions>, inputValue: string) => {
    const { label, value, codEndNoclienteAlfaN } = option.data;
    const searchableFields = [label, value, codEndNoclienteAlfaN];
    return searchableFields.some(field =>
      String(field).toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="NewConsult" />
      <Transitions>
        <Loader isLoading={isLoading} />

        <PageHeader title="Realizar Nova Consulta" />

        <FilterRadioButtonsContainer style={{ marginBottom: '8px' }}>
          <FilterRadioButton selected={consultType === 'default'} onClick={() => handleConsultTypeChange('default')}>
            {isDifferentSubdomain ? 'Pré-admissional (avulso)' : 'Padrão (avulso)'}
          </FilterRadioButton>
          <FilterRadioButton selected={consultType === 'multi'} onClick={() => handleConsultTypeChange('multi')}>
              Multirotas
          </FilterRadioButton>
        </FilterRadioButtonsContainer>

        <span>
          {consultType === 'default' && (
            <>Uma consulta padrão possui o endereço residencial do funcionário, e como destino, apenas o endereço de seu local de trabalho, ela é usada para os funcionários que vão diretamente de sua residência até seu trabalho, sem paradas ou alterações.</>
          )}
          {consultType === 'multi' && (
            <>Uma consulta multi-rotas possui o endereço residencial do funcionário, e possui paradas em um ou mais endereços antes de chegar em seu destino final. Ela é usada, por exemplo, para vendedores que precisam passar em diversos endereços antes de chegar em seu destino final.</>
          )}
        </span>

        {!companyCode && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
                Selecione uma empresa para gerar uma nova consulta.
              </>
            )}
          />
        )}

        {!!companyCode && (
          <>
            {!hasError && !isLoading && (
              <>
                <Card>
                  <SelectedViewContainer>
                    <InnerDataContainer>
                      <h4>
                        <img src={user} alt="" />
                        Dados funcionário
                      </h4>
                      <FormGroup error={getErrorMessageByFieldName('cpf')}>
                        <label htmlFor="contactName">CPF</label>
                        <Input
                          placeholder="CPF do colaborador"
                          value={newConsultData.cpf}
                          onChange={handleCpfChange}
                          autoComplete="new-password"
                          darkBorder
                          error={getErrorMessageByFieldName('cpf')}
                        />
                      </FormGroup>

                      <FormGroup error={getErrorMessageByFieldName('registration')}>
                        <label htmlFor="contactName">Matrícula</label>
                        <Input
                          placeholder="Matrícula do colaborador (Máx. 18 caracteres)"
                          maxLength={18}
                          value={newConsultData.matricula}
                          onChange={handleRegistrationChange}
                          autoComplete="new-password"
                          darkBorder
                          error={getErrorMessageByFieldName('registration')}
                          disabled={!isCpfvalid(newConsultData.cpf)}
                        />
                      </FormGroup>

                      <FormGroup error={getErrorMessageByFieldName('name')}>
                        <label htmlFor="contactName">Nome</label>
                        <Input
                          placeholder="Nome do colaborador"
                          value={newConsultData.nome}
                          onChange={handleNameChange}
                          autoComplete="new-password"
                          darkBorder
                          error={getErrorMessageByFieldName('name')}
                          disabled={!isCpfvalid(newConsultData.cpf)}
                        />
                      </FormGroup>

                      <FormGroup error={getErrorMessageByFieldName('email')}>
                        <label htmlFor="contactName">E-mail</label>
                        <Input
                          placeholder="E-mail do colaborador"
                          value={newConsultData.mail}
                          onChange={handleEmailChange}
                          autoComplete="new-password"
                          darkBorder
                          error={getErrorMessageByFieldName('email')}
                          disabled={!isCpfvalid(newConsultData.cpf)}
                          maxLength={50}
                        />
                      </FormGroup>

                      <FormGroup error={getErrorMessageByFieldName('cellphone')}>
                        <label htmlFor="contactName">Celular</label>
                        <Input
                          placeholder="Celular do colaborador"
                          value={newConsultData.celular}
                          onChange={handleCellphoneChange}
                          autoComplete="new-password"
                          darkBorder
                          error={getErrorMessageByFieldName('cellphone')}
                          disabled={!isCpfvalid(newConsultData.cpf)}
                        />
                      </FormGroup>
                    </InnerDataContainer>

                    <InnerDataContainer>
                      <h4>
                        <img src={home} alt="" />
                        Endereço funcionário
                      </h4>

                      <FullAddressForm
                        lat={(newCoords.split(', ')[0]) ?? ''}
                        lng={(newCoords.split(', ')[1]) ?? ''}
                        cep={newConsultData.cep}
                        streetName={newConsultData.logradouro}
                        number={newConsultData.num}
                        district={newConsultData.bairro}
                        city={newConsultData.cidade}
                        uf={newConsultData.uf}
                        onLatChange={onLatChange}
                        onLngChange={onLngChange}
                        onCepChange={onCepChange}
                        onStreetNameChange={onStreetNameChange}
                        onNumberChange={onNumberChange}
                        onDistrictChange={onDistrictChange}
                        onCityChange={onCityChange}
                        onUfChange={onUfChange}
                        setError={setError}
                        setIsLoading={setIsLoading}
                        removeError={removeError}
                        getErrorMessageByFieldName={getErrorMessageByFieldName}
                      />
                    </InnerDataContainer>

                    <InnerDataContainer>
                      <h4>
                        <img src={companySidebar} alt="" />
                        {consultType === 'default' ? 'Local de trabalho' : 'Locais de trabalho'}
                      </h4>
                      {consultType === 'multi' && (
                        <FormGroup error={getErrorMessageByFieldName('routeName')}>
                          <label htmlFor="contactName">Denominação da Rota</label>
                          <Input
                            placeholder="Ex.: Segunda, Terça, e Sexta-feira"
                            value={routeName}
                            onChange={handleRouteNameChange}
                            autoComplete="new-password"
                            darkBorder
                            error={getErrorMessageByFieldName('routeName')}
                          />
                        </FormGroup>
                      )}

                      <FormGroup>
                        <label htmlFor="contactName">
                          {consultType === 'default' ? 'Selecione o local de trabalho' : 'Selecione os locais de trabalho'}
                        </label>
                        <Select
                          value={consultType === 'default' ? valueLabelByCorrespondingWorkplace : selectedWorkplaces}
                          options={workplacesOptions}
                          onChange={ consultType === 'default' ? (wp) => handleSelectedWorkplaceChange(wp as IWorkplacesOptions) : (opt) => {
                            setSelectedWorkplaces(opt as IWorkplacesOptions[]);
                          }}
                          placeholder={consultType === 'default' ? 'Selecione o local de trabalho' : 'Selecione os locais de trabalho'}
                          styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                          classNamePrefix="react-select"
                          className="react-select-container"
                          isMulti={consultType === 'multi'}
                          components={animatedComponents}
                          filterOption={customWorkplaceSelectFilter}
                          isLoading={isGettingMyPlace}
                        />
                      </FormGroup>

                      {(!!correspondingWorkplace || selectedWorkplaces.length > 0) && (
                        <>
                          {consultType === 'default' && (
                            <>
                              <small>
                                {correspondingWorkplace?.logradouro}, {correspondingWorkplace?.numero} <br /> {correspondingWorkplace?.bairro} - {correspondingWorkplace?.cidade} - {correspondingWorkplace?.UF} <br /> Coordenadas: {correspondingWorkplace?.lat ?? 0}, {correspondingWorkplace?.lng ?? 0}
                              </small>

                              <SecondaryButton style={{ marginTop: 8 }} onClick={() => navigateToWorkplaceEditPage()}>
                                Corrigir Endereço Selecionado
                              </SecondaryButton>
                            </>
                          )}

                          {consultType === 'multi' && (
                            <div className='workplacesContainer'>
                              {selectedWorkplaces.map((workplace, index) => (
                                <div className='workplaceInfoContainer' key={index}>
                                  <small>
                                    #{index + 1} {workplace?.logradouro}, {workplace?.numero} <br /> {workplace?.bairro} - {workplace?.cidade} - {workplace?.UF} <br /> Coordenadas: {workplace?.lat ?? 0}, {workplace?.lng ?? 0}
                                  </small>

                                  <SecondaryButton small style={{ marginTop: 8 }} onClick={() => navigateToWorkplaceEditPage(workplace?.codEnd)}>
                                    Corrigir
                                  </SecondaryButton>
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      )}

                    </InnerDataContainer>
                  </SelectedViewContainer>
                </Card>

                <Card>
                  <SelectedViewContainer>
                    <InnerDataContainer>
                      <h4>
                        <img src={route} alt="" />
                        Critérios de Rota
                      </h4>
                      {consultType === 'default' && (
                        <FormGroup>
                          <label htmlFor="contactName">
                            Espelhamento
                            <img src={info} alt="info" className='primaryColor info' title="O resultado da volta sempre será o inverso do resultado da ida. Isso otimiza o tempo de processamento de uma roteirização, porém pode diminuir a precisão da mesma." />
                          </label>
                          <FilterRadioButtonsContainer>
                            <FilterRadioButton selected={newConsultData.usaEspelhamento} onClick={() => handleUsesMirroringChange(true)}>
                            Utiliza
                            </FilterRadioButton>
                            <FilterRadioButton selected={!newConsultData.usaEspelhamento} onClick={() => handleUsesMirroringChange(false)}>
                            Não Utiliza
                            </FilterRadioButton>
                          </FilterRadioButtonsContainer>
                        </FormGroup>
                      )}

                      {canChooseUsesAffreightment && (
                        <FormGroup>
                          <label htmlFor="contactName">Fretamento</label>
                          <FilterRadioButtonsContainer>
                            <FilterRadioButton selected={newConsultData.usaFretado} onClick={() => handleUsesAffreightmentChange(true)}>
                            Utiliza
                            </FilterRadioButton>
                            <FilterRadioButton selected={!newConsultData.usaFretado} onClick={() => handleUsesAffreightmentChange(false)}>
                            Não Utiliza
                            </FilterRadioButton>
                          </FilterRadioButtonsContainer>
                        </FormGroup>
                      )}

                      <FormGroup>
                        <label htmlFor="contactName">Limite de distância caminhada</label>
                        <RangeSliderContainer>
                          <header>
                            {` ${selectedWalkDistance[1]}m`}
                          </header>
                          <RangeSlider
                            min={500}
                            max={2000}
                            value={selectedWalkDistance}
                            onThumbDragEnd={() => handleWalkDistanceSelection(selectedWalkDistance)}
                            onInput={(evt: number[]) => setSelectedWalkDistance(evt)}
                            className="single-thumb"
                            thumbsDisabled={[true, false]}
                            step={50}
                            rangeSlideDisabled
                          />
                        </RangeSliderContainer>
                      </FormGroup>
                    </InnerDataContainer>

                    <InnerDataContainer>
                      <h4>
                        <img src={coinsSidebar} alt="" />
                        Critérios Financeiros
                      </h4>

                      {consultType === 'default' && (
                        <>
                          <FormGroup error={getErrorMessageByFieldName('ceilingValue')}>
                            <label htmlFor="contactName">Valor Teto</label>
                            <Input
                              placeholder="R$ XX,XX"
                              value={newConsultData.valorTeto || 'Não utiliza'}
                              disabled={!newConsultData.usaTeto}
                              onChange={handleCeilingValueChange}
                              autoComplete="new-password"
                              darkBorder
                              error={getErrorMessageByFieldName('ceilingValue')}
                            />
                          </FormGroup>
                          {/* <FormGroup error={getErrorMessageByFieldName('initialValue')}>
                            <label htmlFor="contactName">Valor Inicial</label>
                            <Input
                              placeholder="R$ XX,XX"
                              value={newConsultData.valorVT}
                              onChange={handleInitialValueChange}
                              autoComplete="new-password"
                              darkBorder
                              error={getErrorMessageByFieldName('initialValue')}
                            />
                          </FormGroup> */}
                        </>
                      )}

                      <FormGroup>
                        <label htmlFor="contactName">
                          SPTRANS (Bilhete comum ou VT)
                          <img src={info} alt="info" className='primaryColor info' title="O VT possui um valor ligeiramente mais alto que o vale comum, por isso algumas empresas optam por realizar a recarga como vale comum, ou reembolsar o colaborador em dinheiro." />
                        </label>
                        <FilterRadioButtonsContainer>
                          <FilterRadioButton selected={!newConsultData.semTaxaVT} onClick={() => handleUsesNoTaxTickets(false)}>
                          Utilização de VT
                          </FilterRadioButton>
                          <FilterRadioButton selected={newConsultData.semTaxaVT} onClick={() => handleUsesNoTaxTickets(true)}>
                          Utilização de Bilhete Comum (mediante liminar da justiça)
                          </FilterRadioButton>
                        </FilterRadioButtonsContainer>
                      </FormGroup>

                      <FormGroup>
                        <label htmlFor="contactName">
                          AESA (Bilhete comum ou VT)
                          <img src={info} alt="info" className='primaryColor info' title="O VT possui um valor ligeiramente mais alto que o vale comum, por isso algumas empresas optam por realizar a recarga como vale comum, ou reembolsar o colaborador em dinheiro." />
                        </label>
                        <FilterRadioButtonsContainer>
                          <FilterRadioButton selected={!newConsultData.regraVTSemTxAesa} onClick={() => handleUsesNoTaxTickets(false)}>
                          Utilização de VT
                          </FilterRadioButton>
                          <FilterRadioButton selected={newConsultData.regraVTSemTxAesa} onClick={() => handleUsesNoTaxTickets(true)}>
                          Utilização de Bilhete Comum (mediante liminar da justiça)
                          </FilterRadioButton>
                        </FilterRadioButtonsContainer>
                      </FormGroup>

                      <FormGroup>
                        <label htmlFor="contactName">Integrações</label>
                        <FilterRadioButtonsContainer>
                          <FilterRadioButton selected={!newConsultData.semIntegraVT} onClick={() => {
                            handleIsHighSalaryChange(false);
                            handleRJIntegration(true);
                          }}>
                            Realiza
                          </FilterRadioButton>
                          <FilterRadioButton selected={newConsultData.semIntegraVT} onClick={() => {
                            handleIsHighSalaryChange(true);
                            handleRJIntegration(false);
                          }}>
                            Não Realiza
                          </FilterRadioButton>
                        </FilterRadioButtonsContainer>
                      </FormGroup>
                    </InnerDataContainer>

                    <InnerDataContainer>
                      <h4>
                        <img src={user} alt="" />
                        Critérios Colaborador
                      </h4>
                      <FormGroup error={getErrorMessageByFieldName('entryTime')}>
                        <label htmlFor="contactName">Horário Entrada</label>
                        <Input
                          type='time'
                          placeholder="00:00"
                          value={newConsultData.horaEntra}
                          onChange={handleEntryTimeChange}
                          autoComplete="new-password"
                          darkBorder
                          error={getErrorMessageByFieldName('entryTime')}
                        />
                      </FormGroup>

                      <FormGroup error={getErrorMessageByFieldName('exitTime')}>
                        <label htmlFor="contactName">Horário Saída</label>
                        <Input
                          type='time'
                          placeholder="00:00"
                          value={newConsultData.horaSai}
                          onChange={handleExitTimeChange}
                          autoComplete="new-password"
                          darkBorder
                          error={getErrorMessageByFieldName('exitTime')}
                        />
                      </FormGroup>

                      {consultType === 'default' && (
                        <FormGroup error={getErrorMessageByFieldName('workDays')}>
                          <label htmlFor="contactName">Turno (dias trabalhados/mês)</label>
                          <Input
                            placeholder="1 a 30"
                            value={newConsultData.diasVT}
                            onChange={handleWorkDaysChange}
                            autoComplete="new-password"
                            darkBorder
                            error={getErrorMessageByFieldName('workDays')}
                          />
                        </FormGroup>
                      )}

                      <FormGroup>
                        <label htmlFor="contactName">Salário</label>
                        <FilterRadioButtonsContainer>
                          <FilterRadioButton selected={newConsultData.salario <= 3200} onClick={() => {
                            handleIsHighSalaryChange(false);
                            handleRJIntegration(true);
                          }}>
                            Abaixo de 3205,20
                          </FilterRadioButton>
                          <FilterRadioButton selected={newConsultData.salario > 3200} onClick={() => {
                            handleIsHighSalaryChange(true);
                            handleRJIntegration(false);
                          }}>
                            Acima de 3205,20
                          </FilterRadioButton>
                        </FilterRadioButtonsContainer>
                      </FormGroup>
                    </InnerDataContainer>
                  </SelectedViewContainer>
                </Card>

                <Button
                  disabled={!isValidToConfirm}
                  style={{ width: '100%', marginTop: '16px'}}
                  onClick={() => sendForRouting()}
                  tooltip={(renderArray(requiredFieldsErrorsLabel) ?? '')}
                  tooltipExplanation='Campos obrigatórios não preenchidos:'
                >
                  Roteirizar
                </Button>
              </>
            )}

            <AsksGoToExistingResultModal
              asksGoToExistingResultModalData={asksGoToExistingResultModalData}
              setAsksGoToExistingResultModalData={setAsksGoToExistingResultModalData}
            />

            {hasError && (
              <NoData
                icon="sad"
                label={(
                  <>
              Ocorreu um erro ao carregar o formulário para criar uma nova consulta.
                    <button type="button" onClick={handleTryAgain}>Tentar Novamente</button>
                  </>
                )}
              />
            )}
          </>
        )}
      </Transitions>
    </>
  );
}
